import util from '@/plugins/util';
export default {
  data() {
    return {
      showDialog: false,
      active: 1,
      mobile: '',
      validCode: '',
      password: '',
      confirmPwd: '',
      checkRegisterSmsFlag: '',
      // 校验登录注册验证码成功的标识
      showGetCode: true,
      // 验证码相关
      count: '',
      timer: null
    };
  },
  methods: {
    show() {
      this.showDialog = true;
    },
    getCode() {
      if (!util.checkPhoneNumber(this.mobile)) {
        this.$message({
          type: "error",
          message: "请输入正确的手机号",
          duration: 1500
        });
        return;
      }
      this.$axios.post('/sms/sendUpdatePwdCode', '', {
        mobile: this.mobile
      }).then(({
        data
      }) => {
        this.countDown(60);
      });
    },
    registerNext() {
      if (this.active == 1) {
        if (!util.checkPhoneNumber(this.mobile)) {
          this.$message({
            type: "error",
            message: "请输入正确的手机号",
            duration: 1500
          });
          return;
        } else if (!this.validCode.trim()) {
          this.$message({
            type: "error",
            message: "请输入验证码",
            duration: 1500
          });
          return;
        } else {
          this.$axios.put('/user/checkUpdatePwdSms', '', {
            mobile: this.mobile,
            validCode: this.validCode
          }).then(({
            data
          }) => {
            this.checkRegisterSmsFlag = data;
            this.active += 1;
          });
        }
      } else if (this.active == 2) {
        var reg = new RegExp("^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\\W]{6,20}$");
        let result = reg.test(this.password);
        if (!this.password.trim()) {
          this.$message({
            type: "error",
            message: "请输入新密码",
            duration: 1500
          });
          return;
        } else if (!result) {
          this.$message({
            type: "error",
            message: "密码由字母加数字或符号至少两种以上字符组成6-20位半角字符，区分大小写",
            duration: 3000
          });
          return;
        } else if (!this.confirmPwd) {
          this.$message({
            type: "error",
            message: "请再次输入密码",
            duration: 1500
          });
          return;
        } else if (this.password != this.confirmPwd) {
          this.$message({
            type: "error",
            message: "两次密码不一致",
            duration: 1500
          });
          return;
        } else {
          let userRegisterParam = {
            checkRegisterSmsFlag: this.checkRegisterSmsFlag,
            // 校验登录注册验证码成功的标识
            mobile: this.mobile,
            password: this.password,
            tempUid: ''
          };
          // 发送请求
          this.$axios.put('/user/updatePwd', '', userRegisterParam).then(({
            data
          }) => {
            this.active += 1;
            setTimeout(() => {
              this.$emit('toOtherOperate', 'changePasseord');
            }, 3000);
            this.countDown(3);
          });
        }
      } else if (this.active == 3) {
        this.$emit('toOtherOperate', 'changePasseord');
      }
    },
    countDown(timeCount) {
      if (!this.timer) {
        this.count = timeCount;
        this.showGetCode = false;
        this.timer = setInterval(() => {
          if (this.active == 2) {
            clearInterval(this.timer);
            this.timer = null;
            this.count = '';
            return;
          } else if (this.count > 0 && this.count <= timeCount) {
            this.count--;
          } else {
            this.showGetCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    closeDialog() {
      this.showDialog = false;
      this.active = 1;
      this.mobile = '';
      this.validCode = '';
      this.password = '';
      this.confirmPwd = '';
      this.checkRegisterSmsFlag = ''; // 校验登录注册验证码成功的标识
      this.showGetCode = true; // 验证码相关
      this.count = '';
      this.timer = null;
    }
  }
};